import type { SearchbarCustomEvent } from '@ionic/react'
import { debounce } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useQueryParam } from 'use-query-params'
import { constants } from '~/shared/config'
import { SCROLLABLE_LIST_PAGE_KEY } from '~/shared/ui/ScrollableList'
import { IonSearchbar } from './styled'

export function Search() {
  const { t } = useTranslation()
  const [search, setSearch] = useQueryParam<string>(constants.HEADER_SEARCH_KEY)
  const [, setPage] = useQueryParam<number>(SCROLLABLE_LIST_PAGE_KEY)

  const handleChange = (value: string) => {
    setSearch(value, 'replace')
    if (!value) setPage(1, 'replace')
  }

  const debouncedSearchChange = debounce(handleChange, 400)

  return (
    <IonSearchbar
      animated
      placeholder={t('form.enter car number')}
      color='warning'
      onIonInput={(e: SearchbarCustomEvent) => {
        debouncedSearchChange(e.detail.value || '')
      }}
      value={search}
      onIonClear={() => {
        debouncedSearchChange('')
      }}
      data-testid='header-search'
      name='header-search'
    />
  )
}
